import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface FilterDialogData {
  title: string;
  filters: FilterField[];
  currentFilters: any;
}

export interface FilterField {
  key: string;
  label: string;
  type: 'text' | 'select' | 'date' | 'dateRange';
  options?: { label: string; value: any }[];
  placeholder?: string;
  apiEndpoint?: string; // For dynamic options loading
}

@Component({
  selector: 'app-filter-dialog',
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.css']
})
export class FilterDialogComponent implements OnInit {
  filters: any = {};
  businessList: any[] = [];
  departmentOptions: any[] = [];
  departmentDisabled: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<FilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FilterDialogData
  ) { }

  ngOnInit(): void {
    this.filters = { ...this.data.currentFilters };
    // If business is already selected, set department options
    if (this.filters.business_id) {
      this.setDepartmentOptions(this.filters.business_id);
    }
  }

  onBusinessChange(businessId: any): void {
    this.filters.department_id = '';
    this.departmentOptions = [];
    this.departmentDisabled = true;
    this.setDepartmentOptions(businessId);
  }

  private setDepartmentOptions(businessId: any): void {
    const selectedBusiness = (this.businessList || []).find(b => b.id == businessId);
    if (selectedBusiness && selectedBusiness.departments) {
      this.departmentOptions = selectedBusiness.departments.map((d: any) => ({ label: d.name, value: d.id }));
      this.departmentDisabled = false;
    } else {
      this.departmentOptions = [];
      this.departmentDisabled = true;
    }
  }

  onApplyFilters(): void {
    this.dialogRef.close(this.filters);
  }

  onClearFilters(): void {
    this.filters = {};
    this.dialogRef.close(this.filters);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}